import { getAccessTokenExpiresAt, hasRefreshToken, refreshAccessToken } from './sessionTokens'

const REFRESH_AHEAD_MS = 30_000
const RETRY_AFTER_FAILURE_MS = 60_000

let timer: ReturnType<typeof setTimeout> | number | null = null

function clearTimer() {
  if (timer !== null) window.clearTimeout(timer)
  timer = null
}

export function cancelProactiveRefresh() {
  clearTimer()
}

export function scheduleProactiveRefresh(onSessionExpired: () => void) {
  clearTimer()
  const expiresAt = getAccessTokenExpiresAt()
  if (!expiresAt) return
  const delay = Math.max(0, expiresAt - Date.now() - REFRESH_AHEAD_MS)
  timer = window.setTimeout(() => {
    void refreshAccessToken().then((token) => {
      if (token) {
        scheduleProactiveRefresh(onSessionExpired)
        return
      }
      if (hasRefreshToken()) {
        timer = window.setTimeout(() => scheduleProactiveRefresh(onSessionExpired), RETRY_AFTER_FAILURE_MS)
        return
      }
      onSessionExpired()
    })
  }, delay)
}
